var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    stroke: "#ED3E3E",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_28568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3338 15.762H17.6671C17.0358 15.7627 16.4307 16.0138 15.9843 16.4602C15.538 16.9065 15.2869 17.5117 15.2861 18.1429V23.8572C15.2869 24.4884 15.538 25.0936 15.9843 25.54C16.4307 25.9863 17.0358 26.2374 17.6671 26.2382H24.3338C24.965 26.2374 25.5702 25.9863 26.0165 25.54C26.4629 25.0936 26.7139 24.4884 26.7147 23.8572V18.1429C26.7139 17.5117 26.4629 16.9065 26.0165 16.4602C25.5702 16.0138 24.965 15.7627 24.3338 15.762ZM17.6671 16.7143H24.3338C24.6189 16.7149 24.8973 16.8008 25.1333 16.9609C25.3692 17.1211 25.5518 17.3481 25.6576 17.6129L22.0109 21.2601C21.7425 21.5274 21.3792 21.6774 21.0004 21.6774C20.6216 21.6774 20.2583 21.5274 19.9899 21.2601L16.3433 17.6129C16.4491 17.3481 16.6317 17.1211 16.8676 16.9609C17.1035 16.8008 17.3819 16.7149 17.6671 16.7143ZM24.3338 25.2858H17.6671C17.2882 25.2858 16.9248 25.1353 16.6569 24.8674C16.389 24.5994 16.2385 24.2361 16.2385 23.8572V18.8572L19.3166 21.9334C19.7636 22.3792 20.3691 22.6296 21.0004 22.6296C21.6317 22.6296 22.2373 22.3792 22.6842 21.9334L25.7623 18.8572V23.8572C25.7623 24.2361 25.6118 24.5994 25.3439 24.8674C25.076 25.1353 24.7126 25.2858 24.3338 25.2858Z",
    fill: "#ED3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_28568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4286,
    height: 11.4286,
    fill: "white",
    transform: "translate(15.2861 15.2858)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailNavIcon);
export default __webpack_public_path__ + "static/media/mail_nav_icon.4748a33048d4f3692eb03167c9ac3868.svg";
export { ForwardRef as ReactComponent };